import { getItemsByExistPriceId, getPosPriceValue } from '../../../../../../helper'
import { getConvertedProduct2Item } from '../../../../../../helper/convertor'

export const sortedToppingsData = (a, b) => a.name?.toLowerCase().localeCompare(b.name?.toLowerCase())

export const convertToppingsToItems = (
	toppingsToShow,
	reduxItemFocus,
	toppingItems,
	orderType,
	toppingPriceId,
	toppingPriceIndex,
	module
) => {
	return toppingsToShow?.map(pr => {
		const qnt = reduxItemFocus?.items?.filter(subItem => subItem.itemId === pr.productId)?.reduce((qs, itm) => qs + itm.quantity, 0) || 0
		const filteredToppings = toppingItems.filter(itm => itm.itemId === pr.productId)
		const qnt2 = filteredToppings.reduce((qs, itm) => qs + itm.quantity, 0)
		const quantity = (filteredToppings.length && qnt !== qnt2) ? qnt2 : qnt
		const toppingItem = getConvertedProduct2Item({ product: pr, quantity, price: getPosPriceValue(pr, orderType, toppingPriceId), priceIndex: toppingPriceIndex, items: null, priceTitleId: toppingPriceId, module })
		return toppingItem
	})?.sort(sortedToppingsData)
}

export const convertToppingGroupsToItems = (
	toppingGroups,
	reduxItemFocus,
	toppingItems,
	orderType,
	toppingPriceId,
	toppingPriceIndex,
	module
) => {
	return toppingGroups?.reduce((res, item) => {
		const items = getItemsByExistPriceId(item.products, orderType, toppingPriceId)
		const groupItems = items?.map(el => {
			const price = getPosPriceValue(el, orderType, toppingPriceId)

			const filteredRedux = reduxItemFocus?.items?.filter(subItem => {
				if (subItem.itemId !== el.productId) return false
				const isCartAddedTopping = !subItem.toppingGroupId && subItem.price === price
				return subItem.toppingGroupId === item.id || isCartAddedTopping
			}) || []
			const qntRedux = filteredRedux.reduce((qs, itm) => qs + itm.quantity, 0) || 0

			const localGroup = toppingItems?.[item.id] || []
			const filteredLocal = localGroup.filter(itm => itm.itemId === el.productId) || []
			const qntLocal = filteredLocal.reduce((qs, itm) => qs + itm.quantity, 0) || 0
			const quantity = (filteredLocal.length && qntLocal !== qntRedux) ? qntLocal : qntRedux
			return getConvertedProduct2Item({
				product: el,
				quantity,
				price,
				priceIndex: toppingPriceIndex,
				items: null,
				priceTitleId: toppingPriceId,
				module
			})
		})?.sort(sortedToppingsData)

		return { ...res, [item.id]: groupItems }
	}, {})
}
